<template>
  <div class="contents-container">
    <b-container>
      <b-row>
        <b-col md="12">
          <h1 class="text-left">Tartalomkezelő</h1>
        </b-col>
      </b-row>

      <b-row>
        <b-col
          v-if="userHaveSpecificPermission(PERMISSION.VALI_CURRENT_PROGRAM_UPDATE)"
          md="6"
          @click="navigateTo('/contents/programs')"
          class="mb-4"
        >
          <div class="content-button-container">
            <img src="../../assets/img/program-image.png" />
            <h2>Programok</h2>
          </div>
        </b-col>

        <b-col
          v-if="userHaveSpecificPermission(PERMISSION.VALI_PRIVATE_SERVICES_UPDATE)"
          md="6"
          @click="navigateTo('/contents/services')"
          class="mb-4"
        >
          <div class="content-button-container">
            <img src="../../assets/img/service-image.png" />
            <h2>Állandó szolgáltatások</h2>
          </div>
        </b-col>

        <b-col
          v-if="userHaveSpecificPermission(PERMISSION.VALI_NEWS_UPDATE)"
          md="6"
          @click="navigateTo('/contents/news')"
          class="mb-4"
        >
          <div class="content-button-container">
            <font-awesome-icon icon="fa-regular fa-newspaper" class="icon" />
            <h2>Hírek</h2>
          </div>
        </b-col>
        <b-col
          v-if="userHaveSpecificPermission(PERMISSION.VALI_ROLE_UPDATE)"
          md="6"
          @click="navigateTo('/contents/access-management')"
          class="mb-4"
        >
          <div class="content-button-container">
            <font-awesome-icon icon="fa-solid fa-user-shield" class="icon" />
            <h2>Jogosultságkezelés</h2>
          </div>
        </b-col>

        <b-col
          v-if="userHaveSpecificPermission(PERMISSION.VALI_COMPLEX_CONDITION_DETAIL)"
          md="6"
          @click="navigateTo('/competitions/complex-filter')"
          class="mb-4"
        >
          <div class="content-button-container">
            <font-awesome-icon icon="fa-solid fa-diagram-successor" class="icon" />
            <h2>Összetett feltételek</h2>
          </div>
        </b-col>
        <b-col
          v-if="userHaveSpecificPermission(PERMISSION.VALI_COMPETITION_DETAIL)"
          md="6"
          @click="navigateTo('/competitions')"
          class="mb-4"
        >
          <div class="content-button-container">
            <font-awesome-icon icon="fa-solid fa-chalkboard-user" class="icon" />
            <h2>Pályázatok</h2>
          </div>
        </b-col>

        <b-col md="6" @click="navigateTo('/fund-categories')" class="mb-4">
          <div class="content-button-container">
            <font-awesome-icon icon="fa-solid fa-object-group" class="icon" />
            <h2>Forrás kategóriák</h2>
          </div>
        </b-col>

        <b-col md="6" @click="navigateTo('/system-email/home')" class="mb-4">
          <div class="content-button-container">
            <font-awesome-icon icon="fa-solid fa-envelope" class="icon" />
            <h2>Rendszerüzenetek</h2>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { PERMISSION } from '../../constants/permissions'
export default {
  name: 'Contents',
  methods: {
    navigateTo: function(link) {
      this.$router.push(link)
    }
  },
  computed: {
    ...mapGetters(['userHaveSpecificPermission'])
  },
  data() {
    return {
      PERMISSION
    }
  }
}
</script>
<style scoped>
.content-button-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  width: 100%;
  gap: 40px;
  border: 1px solid var(--color-gray-02);
  box-shadow: 0px 2px 8px rgba(99, 110, 114, 0.2);
  border-radius: 8px;
  transition: box-shadow 0.1s ease-in-out, background-color 0.1s ease-in-out;
  cursor: pointer;
  padding: 20px;
}

.content-button-container:hover {
  box-shadow: 0px 2px 25px rgba(99, 110, 114, 0.2);
}

.icon {
  color: #00903c;
  font-size: 72px;
}

img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

h2 {
  color: var(--color-green);
  font-size: 24px;
}

@media screen and (min-width: 992px) {
  .contents-container {
    margin-left: 75px;
    margin-right: 75px;
  }
}
</style>
